"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignRule = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const system_1 = __importDefault(require("@/pages/index/api/system"));
const dict_1 = require("@/pages/index/select/dict");
const dictionary_1 = require("@/config/dictionary");
const config_1 = require("@/config/dictionary/config");
const select_1 = require("@/pages/index/select");
class AssignRule extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            system_1.default.assignRuleBuild.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            system_1.default.assignRuleChange.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    deleteItem() {
        return new Promise((resolve, reject) => {
            system_1.default.assignRuleDelete.require(this.$module.choice.getId()).then(() => {
                this.$module.choice.$reset();
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.AssignRule = AssignRule;
exports.default = (0, vue_1.defineComponent)({
    name: 'AssignRule',
    components: {
        ListView: ListView_1.default
    },
    data() {
        const mainData = new AssignRule({
            name: '分派规则',
            prop: 'assignRule',
            module: {
                pagination: true,
                choice: {},
                search: {
                    module: {
                        dictionary: {
                            layout: {
                                default: {
                                    grid: 8,
                                    label: 8,
                                    content: 16
                                }
                            },
                            list: [
                                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.ASSIGN_TYPE, {
                                    prop: 'assignType',
                                    name: '类型',
                                    originProp: 'assignType',
                                    mod: {
                                        search: {
                                            $target: 'edit'
                                        }
                                    }
                                }),
                                (0, dictionary_1.buildDictionaryBySelect)(select_1.areaRegion, {
                                    prop: 'assignOrg',
                                    name: '区域',
                                    originProp: 'assignOrg',
                                    mod: {
                                        search: {
                                            $target: 'edit'
                                        }
                                    }
                                }),
                                (0, dictionary_1.buildDictionaryBySelect)(select_1.operationPersonnel, {
                                    prop: 'assignPerson',
                                    name: '分派人员',
                                    originProp: 'assignPerson',
                                    mod: {
                                        search: {
                                            $target: 'edit'
                                        }
                                    }
                                }),
                            ]
                        }
                    },
                    menu: {
                        list: []
                    },
                },
                dictionary: {
                    layout: {
                        default: {
                            grid: 24,
                            label: 7,
                            content: 17
                        }
                    },
                    option: {},
                    propData: {
                        id: 'id'
                    },
                    list: [
                        {
                            prop: 'id',
                            name: 'ID',
                            originProp: 'id',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'assignCode',
                            name: '规则编号',
                            originProp: 'assignCode',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: 140
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.ASSIGN_TYPE, {
                            prop: 'assignType',
                            name: '类型',
                            originProp: 'assignType',
                            originFrom: 'list',
                            mod: {
                                list: {},
                                edit: {
                                    required: true
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.DAY_NUM, {
                            prop: 'day',
                            name: '天数',
                            originProp: 'day',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.getWidth(3, 3)
                                },
                                edit: {
                                    required: true
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        (0, dictionary_1.buildDictionaryBySelect)(select_1.areaRegion, {
                            prop: 'assignOrg',
                            name: '区域',
                            originProp: 'assignOrg',
                            originFrom: 'list',
                            mod: {
                                list: {},
                                edit: {
                                    required: true
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        (0, dictionary_1.buildDictionaryBySelect)(select_1.operationPersonnel, {
                            prop: 'assignPerson',
                            name: '分派人员',
                            originProp: 'assignPerson',
                            originFrom: 'list',
                            mod: {
                                list: {},
                                edit: {
                                    required: true
                                },
                                build: {
                                    $target: 'edit'
                                },
                                change: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'remark',
                            name: '备注',
                            originProp: 'remark',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'createdName',
                            name: '创建人',
                            originProp: 'createdName',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.personnelName
                                }
                            }
                        },
                        {
                            prop: 'createdBy',
                            name: '创建人',
                            originProp: 'createdBy',
                            originFrom: 'list'
                        },
                        {
                            prop: 'createdTime',
                            name: '创建时间',
                            originProp: 'createdTime',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.time
                                }
                            }
                        },
                        {
                            prop: 'updatedBy',
                            name: '最后更新人',
                            originProp: 'updatedBy',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'updatedTime',
                            name: '更新时间',
                            originProp: 'updatedTime',
                            originFrom: 'list',
                            mod: {}
                        },
                        {
                            prop: 'menu',
                            name: '操作',
                            originProp: 'menu',
                            originFrom: 'list',
                            mod: {
                                list: {
                                    width: config_1.listWidth.getWidth(2)
                                }
                            }
                        },
                    ]
                }
            },
            $getData() {
                return new Promise((resolve, reject) => {
                    system_1.default.assignRuleList.require(Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                        this.$formatList(res.data.data, res.data.totalCount);
                        resolve({ status: 'success' });
                    }).catch(err => {
                        // eslint-disable-next-line no-console
                        console.error(err);
                        reject(err);
                    });
                });
            }
        });
        return {
            mainData,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {
                // layout: 'horizontal'
                },
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    },
                    {
                        prop: 'build',
                        name: '新增',
                        type: 'primary'
                    },
                    {
                        prop: 'delete',
                        name: '删除',
                        type: 'danger',
                        disabled() {
                            return mainData.$module.choice.getId().length === 0;
                        }
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'change',
                            name: '编辑'
                        }
                    ]
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        }
    }
});
